<script lang="ts">
  export let svgStyles: string = ''
</script>

<svg width="1016" height="523" viewBox="0 0 1016 523" fill="none" xmlns="http://www.w3.org/2000/svg" class={svgStyles}>
  <circle cx="508" cy="508" r="507.5" stroke="#272D37" />
  <path
    d="M970.163 297.428L986.455 304.979L979.157 321.386L962.497 313.973L970.163 297.428Z"
    fill="url(#paint0_linear_1_19)"
  />
  <defs>
    <linearGradient
      id="paint0_linear_1_19"
      x1="980.628"
      y1="297.458"
      x2="965.966"
      y2="323.214"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#24CAFF" />
      <stop offset="0.7" stop-color="#FDB1A8" />
      <stop offset="1" stop-color="#FFA564" />
    </linearGradient>
  </defs>
</svg>
